<ng-container
  *ngIf="{
    switch: switch$ | async,
  } as content"
>
  <div class="container">
    <h2>{{ 'cart.import.title' | translate }}</h2>

    <div class="import-content">
      <div class="import-content-main">
        <div class="import-content-main-description">
          <div class="import-content-main-description-text">
            <strong>{{ 'cart.import.description' | translate }}</strong>
            <p>{{ 'cart.import.instructions' | translate }}</p>
            <p>
              {{ 'cart.import.fileFormat' | translate }}
            </p>
          </div>

          <div class="import-content-main-description-icon">
            <span class="material-symbols-outlined"> file_save </span>
            <div>
              <strong>{{ 'cart.import.modelDownload' | translate }}</strong>
              <p>{{ 'cart.import.modelFile' | translate }}</p>
            </div>
          </div>
        </div>

        <div class="import-content-main-file">
          <cx-input-file
            [invalid]="!!control.errors?.['importInputFile']"
            [valid]="!control.errors?.['importInputFile'] && !!control.value"
            [hintText]="!control.errors?.['importInputFile'] && !!control.value ? 'ENVIO EFETUADO COM SUCESSO' : ''"
            [control]="control"
            [placeholder]="'Nenhum arquivo escolhido'"
          />

          <import-products [control]="control" />
        </div>

        <import-error [control]="control" />
      </div>

      <div class="import-content-side">
        <div class="import-content-side-header">
          <h3>{{ 'cart.import.subtitle' | translate }}</h3>
        </div>

        <div class="import-content-side-body">
          <cx-switcher
            [id]="content.switch?.id ?? ''"
            (checkedChange)="onCheck($event)"
            [checked]="content.switch?.enabled ?? false"
            [label]="content.switch?.label ?? ''"
          >
          </cx-switcher>

          <cx-button [disabled]="!!control.errors?.['importInputFile'] || !control.value" [icon]="'shopping_cart'" class="w-100">{{
            'cart.import.submit' | translate
          }}</cx-button>
        </div>
      </div>
    </div>
  </div>
</ng-container>
